import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.classList.contains("timeline-revealed")) return
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    if (!("IntersectionObserver" in window)) return

    this.element.classList.add("timeline-pending")
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return

      this.element.classList.remove("timeline-pending")
      this.element.classList.add("timeline-revealed")
      this.observer.disconnect()
    }, {threshold: 0.25, rootMargin: "0px 0px -12% 0px"})

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
